module.exports = __webpack_public_path__ + "img/restaurant.1eff1438.svg";